'use strict'

var React = require('react');
var HorizontalScrollBar = require('../common/HorizontalScrollBar');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

var HorizontalScrollBarCom = React.createClass({

  render: function () {
    return (<HorizontalScrollBar
      backgroundColor={'#fff'}
      value={styleHelper.getInt(this.props,propConst.PROGRESS)}
    />);
  }
});

module.exports = HorizontalScrollBarCom;




// WEBPACK FOOTER //
// ./src/views/Components/HorizontalScrollBarCom.jsx